/* eslint-disable camelcase, no-invalid-this */
import { html } from 'lit-element';
import { ifDefined } from 'lit-html/directives/if-defined';

const dateInputToValue = detail => {
  if (detail && detail[0] && detail[0].getTime) {
    return detail[0].getTime().toString();
  }
};

const valueToDateInput = value => {
  if (value) {
    return [{ dateInstance: new Date(Number(value)) }];
  }
};

export const render_date = function() {
  const { value, disabled, right, format = 'MM/DD/YYYY', dateOptions } = this;

  // if allowed to select future year in the date field, override the date picker dropdowns options with maxYear to next year
  const datePickerOptions = dateOptions?.allowFutureYear
  ? { dropdowns: { maxYear: new Date().getFullYear() + 1 } }
  : {};

  const dates = valueToDateInput(value);
  return html`
    <fc-date-picker
        ?right="${right}"
        .dates="${ifDefined(dates)}"
        @change="${({ detail }) => this.setValue(dateInputToValue(detail))}"
        ?disabled="${disabled}"
        .pickerOptions="${ifDefined(datePickerOptions)}"
        lang="en-US"
        format="${format}">
    </fc-date-picker>
    `;
};
